import isString from 'lodash/isString'

export default {
  setTheme (state, theme) {
    state.dark = !!theme.dark
    state.primaryColor = theme.primaryColor
    state.forgotLinkColor = isString ? JSON.parse(theme.forgotLinkColor) : theme.forgotLinkColor
    state.profileBGImage = theme.profileBGImage
    state.bannerImage = theme.bannerImage
    state.logoLogin = theme.logoImage
    state.logoHeight = theme.logoHeight
    state.loginStart = isString ? JSON.parse(theme.loginStart) : theme.loginStart
    state.loginEnd = isString ? JSON.parse(theme.loginEnd) : theme.loginEnd
    state.logoContrast = !!theme.logoContrast
    state.logoContrastType = theme.logoContrastType
  },
  clearTheme (state) {
    state.dark = true
    state.primaryColor = 'light-blue darken-3'
    state.forgotLinkColor = {hex: '#0277BD'}
    state.profileBGImage = '/static/generic-profile.png'
    state.bannerImage = 'https://storage.googleapis.com/cp-conduit-storage/themes/default/background-triangles.svg'
    state.logoLogin = 'https://storage.googleapis.com/cp-conduit-storage/themes/default/logo.svg'
    state.logoHeight = 72
    state.loginStart = {hex: '#428D94'}
    state.loginEnd = {hex: '#005a70'}
    state.logoContrast = true
    state.logoContrastType = 'light'
  },
  setLogo (state, logo) {
    state.logoMainCurrent = logo
  }
}
